"use strict";

($dt => {

	const controller = {

		CreateGrid: container => {
			const grid = {
				wrapper: container,
				view: 'grid',
				expanded: false,
				filters: [],
				test_elem: elem => {
					let is_match = true;
					const filters = grid.filters;

					filters.forEach(filter => {
						if (is_match && filter.values.length > 0) {
							
							const elem_values = elem.getAttribute('data-' + filter.key);
							let contains_value = false;
							
							filter.values.forEach(val => {
								if (elem_values.includes('|' + val + '|')) {
									contains_value = true;
								}
							});
							if (!contains_value) {
								is_match = false;
							}
						}
					});

					return is_match;
				}
			};

			controller.ConfigureViewToggle(grid);
			controller.ConfigureFilters(grid);
			controller.ReadFilters(grid);
			controller.ConfigureLoadMore(grid);
		},

		ConfigureLoadMore: grid => {
			const { wrapper } = grid;
			const btn_load_more = wrapper.querySelector('.button-load-more');
			if (btn_load_more) {
				btn_load_more.addEventListener('click', () => {
					grid.expanded = true;
					controller.Refresh(grid);
					btn_load_more.remove();
				});
			} else {
				grid.expanded = true;
			}
		},

		ConfigureViewToggle: grid => {
			const { wrapper } = grid;

			const buttons = wrapper.querySelectorAll('.view-toggle .toggle');
			buttons.forEach(elem => {
				const elem_view = elem.getAttribute('data-view-type');
				elem.addEventListener('click', () => {
					if (grid.view !== elem_view) {
						grid.view = elem_view;

						buttons.forEach(el => {
							if (el === elem) {
								el.classList.add('active');
							} else {
								el.classList.remove('active');
							}
						});

						switch (grid.view) {
							case 'grid':
								wrapper.classList.add('view-grid');
								wrapper.classList.remove('view-list');
								break;
							case 'list':
								wrapper.classList.add('view-list');
								wrapper.classList.remove('view-grid');
								break;
						}

						controller.Refresh(grid);
					}
				});
			});
		},

		ConfigureFilters: grid => {
			const { wrapper, filters } = grid;

			// Collect Filters
			const [ filter_elems, fieldset_elems, button_elems, arrow_elems ] = [ 
				wrapper.querySelectorAll('.filter-dropdown'),
				wrapper.querySelectorAll('.filter-dropdown fieldset'),
				wrapper.querySelectorAll('.filter-dropdown button.label'),
				wrapper.querySelectorAll('.filter-dropdown > svg')
			];
			filter_elems.forEach(elem => {
				filters.push({
					key: elem.getAttribute('data-filter-key'),
					values: []
				});
			});

			// Focus buttons
			button_elems.forEach(elem => {
				const filter_parent = elem.parentElement;
				
				// This focus approach is nice for people who are tabbing, but because they are buttons it should be acceptable for ADA to require click to expand
				/*elem.addEventListener('focus', () => {
					if (!filter_parent.classList.contains('active')) {
						filter_parent.classList.add('active');
					}
				});*/

				// Click open/close approach allows for a more traditional dropdown like experience
				elem.addEventListener('click', () => {
					if (!filter_parent.classList.contains('active')) {
						filter_parent.classList.add('active');
					} else {
						filter_parent.classList.remove('active');
					}
				});
			});

			// Arrows with expand contract
			arrow_elems.forEach(elem => {
				const filter_parent = elem.parentElement;
				elem.addEventListener('click', () => {
					if (!filter_parent.classList.contains('active')) {
						filter_parent.classList.add('active');
					} else {
						filter_parent.classList.remove('active');
					}
				});
			});

			// Filter dropdown menus
			document.addEventListener('click', e => {
				const path = e.composedPath ? e.composedPath() : e.path;
				if (path && Array.isArray(path)) {
					let [ clicked_filter, clicked_fieldset, active_filters ] = [ false, false, [] ];

					filter_elems.forEach(elem => {
						if (elem.classList.contains('active')) {
							active_filters.push(elem);
						}
					});

					// Bubble up path, low index = first click and up = parents
					path.forEach(p => {

						// Try to see if a specific filter was clicked
						if (!clicked_filter) {
							filter_elems.forEach(elem => {
								if (p === elem) {
									clicked_filter = elem;
								}
							});
						}

						// Rule out fieldset clicks
						if (!clicked_fieldset) {
							fieldset_elems.forEach(elem => {
								if (p === elem) {
									clicked_fieldset = elem;
								}
							});
						}
					});
					
					if (!clicked_filter) {
						// No filter clicked, close any active
						active_filters.forEach(elem => {
							elem.classList.remove('active');
						});
					} else {
						// Filter clicked
						if (!clicked_fieldset) {
							// Valid click on menu, toggle active
							// The focus event listener will expand menu, this code is no longer needed
							/*if (clicked_filter.classList.contains('active')) {
								clicked_filter.classList.remove('active');
							} else {
								clicked_filter.classList.add('active');
							}*/
						}
					}
				}
			});

			// Configure Buttons
			const [ button_search, button_reset, mobile_filter, filters_row ] = [ 
				wrapper.querySelector('.button-view-results'),
				wrapper.querySelector('.button-reset'),
				wrapper.querySelector('.mobile-filter'),
				wrapper.querySelector('.filters')
			];

			if (button_reset) {
				button_reset.addEventListener('click', () => {
					controller.ClearFilters(grid);
					controller.Refresh(grid);
				});
			}

			if (button_search) {
				button_search.addEventListener('click', () => {
					controller.ReadFilters(grid);
					controller.Refresh(grid);
					filters_row.classList.remove('active');
				});
			}

			if (mobile_filter) {
				mobile_filter.addEventListener('click', () => {
					filters_row.classList.add('active');
				});
			}
		},

		ReadFilters: grid => {
			const { wrapper, filters } = grid;

			filters.forEach(f => {
				const elems = wrapper.querySelectorAll('input[name="' + f.key + '"]');
				f.values = [];
				elems.forEach(el => {
					if (el.checked) {
						f.values.push(el.value);
					}
				});
			});
		},

		ClearFilters: grid => {
			const { wrapper, filters } = grid;
			filters.forEach(f => {
				f.values = [];
			});

			const [ checkbox_elems ] = [
				wrapper.querySelectorAll('input[type="checkbox"]')
			];

			checkbox_elems.forEach(elem => {
				elem.checked = false;
			});
		},

		Refresh: grid => {
			const { wrapper } = grid;
			const [ grid_elems, no_results_elem ] = [ wrapper.querySelectorAll('.grid-item'), wrapper.querySelector('.no-results') ];

			let active_count = 0;
			//console.log(grid.filters);
			grid_elems.forEach(elem => {
				let visible = grid.test_elem(elem);
				if (visible && (grid.expanded || active_count < 9)) {
					elem.classList.add('active-grid');
				} else {
					elem.classList.remove('active-grid');
				}
					
				if (visible && (grid.expanded || active_count < 5)) {
					elem.classList.add('active-list');
				} else {
					elem.classList.remove('active-list');
				}

				if (visible) {
					active_count++;
				}
			});

			if (active_count === 0) {
				no_results_elem.classList.add('active');
			} else {
				no_results_elem.classList.remove('active');
			}

			if (!grid.expanded) {
				const row_load_more = wrapper.querySelector('.load-more');
				if (row_load_more) {
					const max = grid.view === 'list' ? 5 : 9;
					if (active_count >= max) {
						row_load_more.classList.add('active');
					} else {
						row_load_more.classList.remove('active');
					}
				}
			}
		}
	};
	
	$dt.Grid = controller;
	
})(window.d3_wp_themejs);
